export default __webpack_public_path__ + "static/musa-balthazaurus-scroll-f2d7407c1095392b42d6806c66a566d2.mp4";